const map = {
  // 利润中心
  profitcenter: () => import('@/views/profitcenter/profitCenter') // 利润中心
}

export default map
